import React, { useEffect, useState } from "react";
import "../../../style/main.scss";
import { Icon } from "@iconify/react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { HashLoader } from "react-spinners";
const Knowledge = () => {
  const [agentModal, setAgentModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [selectModal, setSelectModal] = useState(false);
  const [faqModal, setFaqModal] = useState(false);
  const [fileModal, setFileModal] = useState(false);
  const [enteredName, setEnteredName] = useState("");
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [nameError, setNameError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showRecording, setRecordingShow] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [fileGenerated, setFileGenerated] = useState();
  const [prompt, setPrompt] = useState();
  const [knowledgeAgents, setKnowledgeAgents] = useState([]);
  const [currentlyCreatedAgent, setCurrentlyCreatedAgent] = useState();
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [loadingForLoader, setLoadingForLoader] = useState(false);

  const navigate = useNavigate();
  var authToken = localStorage.getItem("bearerToken");
  const handleAgentModal = () => {
    setAgentModal(!agentModal);
  };

  const handleManuallyAddFaq = async () => {
    if (question && answer) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/question-answer/${currentlyCreatedAgent._id}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify({
              question,
              answer,
            }),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            console.log("la", data);
            // navigate("/script", { state: { scriptResponse: data.prompt } });
            navigate("/Document_Preview", {
              state: { knowledgeId: currentlyCreatedAgent._id },
            });
          })
          .catch((error) => console.error(error));
        // const headers = {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`,
        // };
        // axios
        //   .post(
        //     "https://voxr-nodejs-f38a2258c1d0.herokuapp.com/customer/text",
        //     {
        //       data: { promptType: promptType },
        //     },
        //     headers
        //   )
        //   .then((res) => {
        //     console.log(res);
        //     navigate("/script", { state: { scriptResponse: res.data } });
        //   })
        //   .catch((err) => {
        //     console.log(err);
        //   });
        // setResponse(response.data);
        // const data = response.data;
        // const bearerToken = data.token;
        // console.log(promptType, "promptType");
        // console.log({
        //   headers: {
        //     Authorization: `Bearer ${authToken}`,
        //     // Authorization: `Bearer ${""}`,
        //   },
        // });
        // console.log("Response:", response.json());
      } catch (error) {
        console.error("Error:", error.message);
      }
    }

    // navigate("/Manually_Added_Doc");
  };
  const handleUploadDocumentPreview = () => {
    navigate("/Document_Preview");
  };
  const handleUploadModal = () => {
    setAgentModal(false);
    setUploadModal(!uploadModal);
  };

  const handleSelectModal = () => {
    setUploadModal(false);
    setSelectModal(!selectModal);
  };

  const handleFaqModal = () => {
    setSelectModal(false);
    setFaqModal(!faqModal);
  };

  const handleFileModal = () => {
    setFaqModal(false);
    setFileModal(!fileModal);
  };

  const handleInputChange = (e) => {
    setEnteredName(e.target.value);
    setError(null);
  };
  const handleKnowledgeBaseName = async () => {
    // console.log(enteredName, "enteredName.length");

    if (enteredName) {
      console.log("Entere");
      setUser(enteredName);
      // setEnteredName("");
      setError(null);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/create-knowledge`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify({
              name: enteredName,
            }),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            console.log("After upload", data);
            setCurrentlyCreatedAgent(data);
          })
          .catch((error) => console.error(error));
        // const headers = {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`,
        // };
        // axios
        //   .post(
        //     "https://voxr-nodejs-f38a2258c1d0.herokuapp.com/customer/text",
        //     {
        //       data: { promptType: promptType },
        //     },
        //     headers
        //   )
        //   .then((res) => {
        //     console.log(res);
        //     navigate("/script", { state: { scriptResponse: res.data } });
        //   })
        //   .catch((err) => {
        //     console.log(err);
        //   });
        // setResponse(response.data);
        // const data = response.data;
        // const bearerToken = data.token;
        // console.log(promptType, "promptType");
        // console.log({
        //   headers: {
        //     Authorization: `Bearer ${authToken}`,
        //     // Authorization: `Bearer ${""}`,
        //   },
        // });
        // console.log("Response:", response.json());
        setEnteredName("");
      } catch (error) {
        console.error("Error:", error.message);
      }

      handleUploadModal();
    } else {
      console.log("else Entere");
      setNameError("Please Enter Name");
    }
  };

  const UploadFileToS3 = async (file, fileFolderPath) => {
    // console.log(file);
    // console.log(fileFolderPath);
    const convertedFile = await convertToBase64(file);
    console.log(fileFolderPath);
    return new Promise(async (resolve, reject) => {
      try {
        //Url set in the server. Server will return s3 object download url
        let url = `${process.env.REACT_APP_API_URL}/aws-Fileupload`;
        // setLoading(true);
        axios
          .post(
            url,
            {
              file: convertedFile,
              fileFolderPath: fileFolderPath,
              fileName: file.name,
              fileType: file.type,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            }
          )
          .then((response) => {
            console.log("response", response);
            if (response.data.success == true) {
              console.log(
                "response.data.thumbnail_url",
                response.data.file_url
              );
              if (response.data.file_url) {
                const myUrl = response.data.file_url;
                console.log("Hammad's url", myUrl);
              }
              resolve({
                success: true,
                file_url: response.data.file_url,
              });
            } else {
              reject({ success: false, error: response.data.error });
            }
          })
          .catch((err) => {
            console.log(err);
            reject({ success: false, error: err });

            toast.error(`Error! Please try again`, { toastId: "awsError" });
          });
      } catch (error) {
        console.log(error);
        reject({ success: false, error });
        toast.error(`Error! Please try again`, { toastId: "awsError" });
      }
    });
  };
  const convertToBase64 = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      };
    });
  };
  // const [file, setFile] = useState(null);
  // const [fileFolderPath, setFileFolderPath] = useState("");
  const handleFileChange = (event) => {
    const File = event.target.files[0];
    // console.log(File);
    const fileFolderPath = "Document";
    console.log("file: ", File);
    if (File) {
      UploadFileToS3(File, fileFolderPath)
        .then((result) => {
          // setLoading(true);
          console.log("Upload successful:", result);
          handleUploadResponse(result.file_url, File.type);

          // handleGetGptResponse(result.thumbnail_url);
        })
        .catch((error) => {
          toast.error("Error Uploading Document!");
          console.error("Upload failed:", error);
        });
    } else {
      console.error("No file selected.");
    }
  };

  const handleUploadResponse = async (url, fileType) => {
    // console.log("url", url);
    try {
      setFileModal(true);
      setLoading(true);
      // console.log("inside functtion===========================", url);
      let data = {
        file: url,
        fileType: fileType,
      };
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        // url: `${process.env.REACT_APP_API_URL}/questions/${currentlyCreatedAgent._id}`,
        url: `${process.env.REACT_APP_API_URL}/questions/${currentlyCreatedAgent._id}`,
        // url: "http://localhost:3000/customer/questions/656577484b2857e5dc3d0534",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        data: data,
      };
      // console.log("inside functtion", url);

      axios
        .request(config)
        .then((response) => {
          console.log("inside functtion", url);
          console.log(JSON.stringify(response.data));

          //display back prompt
          if (response.data) {
            const GeneratedResponse = response.data;
            setFileGenerated(GeneratedResponse);
            setFileModal(false); // gpt response modal
            // setGptCloneModal(true); // gpt response modal
            setLoading(false);
            navigate("/Document_Preview", {
              state: { knowledgeId: currentlyCreatedAgent._id },
            });
            // console.log(
            //   { state: { knowledgeResponse: response.data } },
            //   "state: { knowledgeResponse: data },"
            // );
          }
          //hide modal
          //add loader
        })
        .catch((error) => {
          console.log("Here");
          setLoading(false);
          toast.error("Error Generating Questions");
          console.log(error);
        });
      // let data = JSON.stringify({ file: url });
      // axios
      //   .post(
      //     "https://voxr-nodejs-f38a2258c1d0.herokuapp.com/customer/transcribe/656577484b2857e5dc3d0534",
      //     data,
      //     {
      //       headers: {
      //         "Content-Type": "application/json",
      //         // Accept: "*/*",
      //         // Authorization: `Bearer ${authToken}`,
      //       },
      //     }
      //   )
      //   .then((response) => {
      //     console.log(response, "gpt response");
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
      // console.log(res, "gpt response");
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };
  const handleQAResponse = async (url) => {
    // console.log("url", url);
    try {
      // setFileModal(true);
      // setLoading(true);
      // console.log("inside functtion===========================", url);
      let data = {
        file: url,
        fileType: "pdf",
        prompt: prompt,
      };
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        // url: `${process.env.REACT_APP_API_URL}/questionTest/656577484b2857e5dc3d0534`,
        url: "http://localhost:3000/questionTest/656577484b2857e5dc3d0534",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      // console.log("inside functtion", url);

      axios
        .request(config)
        .then((response) => {
          console.log("inside functtion", url);
          console.log(JSON.stringify(response.data));

          //display back prompt
          if (response.data) {
            const GeneratedResponse = response.data;
            setFileGenerated(GeneratedResponse);
            setFileModal(false); // gpt response modal
            // setGptCloneModal(true); // gpt response modal
            setLoading(false);
            navigate("/Document_Preview", {
              state: { knowledgeResponse: response.data },
            });
            console.log(
              { state: { knowledgeResponse: response.data } },
              "state: { knowledgeResponse: data },"
            );
          }
          //hide modal
          //add loader
        })
        .catch((error) => {
          console.log(error);
        });
      // let data = JSON.stringify({ file: url });
      // axios
      //   .post(
      //     "https://voxr-nodejs-f38a2258c1d0.herokuapp.com/customer/transcribe/656577484b2857e5dc3d0534",
      //     data,
      //     {
      //       headers: {
      //         "Content-Type": "application/json",
      //         // Accept: "*/*",
      //         // Authorization: `Bearer ${authToken}`,
      //       },
      //     }
      //   )
      //   .then((response) => {
      //     console.log(response, "gpt response");
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
      // console.log(res, "gpt response");
    } catch (err) {
      console.log(err);
    }
  };

  const getAllAgent = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/knowledge-agent`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log(data);
      setKnowledgeAgents(data.knowledgeAgents);
      console.log(data);
    } catch (error) {
      console.error("Error fetching agent:", error);
    }
  };

  useEffect(() => {
    getAllAgent();
  }, []);

  const handleDeleteKnowledgebase = async (agentId) => {
    setLoadingForLoader(true);
    let config = {
      method: "delete",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/knowledge-agent/${agentId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        getAllAgent();
        setLoadingForLoader(false);
      })
      .catch((error) => {
        setLoadingForLoader(false);
        console.log(error);
      });
  };

  return (
    <div>
      <div className="knowledge">
        <h1 className="">Create Your First Knowledge Base</h1>
        <h4 className="mt-5 fs-5">
          Create a knowledge base to give your agents important context and
          information about your company. Once your agent is connected to a
          knowledge base, it will have the ability to handle literally thousands
          of FAQs, overcome any objection and more... with perfect recall and
          infinite memory.
        </h4>
        <div className="agent-btn mt-5 mb-3">
          <button onClick={handleAgentModal}>New Knowledge Base</button>
        </div>
        <table className="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Name</th>
              {/* <th scope="col">Last</th>
              <th scope="col">Handle</th> */}
            </tr>
          </thead>
          <tbody>
            {knowledgeAgents.length > 0 ? (
              knowledgeAgents.map((knowledgeAgent, index) => (
                <tr key={index}>
                  <th
                    scope="row"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate("/Document_Preview", {
                        state: { knowledgeId: knowledgeAgent._id },
                      })
                    }
                  >
                    {index + 1}
                  </th>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate("/Document_Preview", {
                        state: { knowledgeId: knowledgeAgent._id },
                      })
                    }
                  >
                    {knowledgeAgent.name}
                  </td>
                  {/* <td>{knowledgeAgent.promptType}</td> */}
                  <td>
                    <div className="Iconss">
                      <Icon
                        icon="fluent:delete-24-regular"
                        color="#dc2626"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          handleDeleteKnowledgebase(knowledgeAgent._id)
                        }
                      />
                      {/* <Icon icon="uil:copy" /> */}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No knowledge base available</td>
              </tr>
            )}
          </tbody>
        </table>

        <Modal show={loadingForLoader} centered size="lg">
          <Modal.Header>
            <Modal.Title>Deleting Knowledge Base...</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              className="loader"
              style={{
                // position: "absolute", width: "100%", zIndex: "2"

                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100px",
              }}
            >
              <HashLoader color="#0C72F7" />
              {/* <h3 id="h3loader">AI is analyzing content...</h3> */}
            </div>
          </Modal.Body>
        </Modal>

        {/* Modal 1 */}
        <Modal show={agentModal} onHide={handleAgentModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Create a New Knowledge Base</Modal.Title>
          </Modal.Header>
          <Modal.Body className="knowledge-base-modal">
            <div className="create-AI">
              <div className="top">
                <p className="create">
                  Create a new knowledge base for voxr to answer questions for
                  you
                </p>
              </div>
              <div className="bottom mt-3">
                <h6>Name</h6>
                <input
                  type="text"
                  name=""
                  id=""
                  value={enteredName}
                  placeholder="eg. Support Knowledge base"
                  onChange={handleInputChange}
                />
              </div>
              {nameError && (
                <p style={{ color: "red", marginLeft: "85px" }}>{nameError}</p>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className=" knowledge-button">
            <div className="knowledge-btn">
              <button onClick={handleKnowledgeBaseName}>Create</button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
      {/* Modal 2 */}
      <Modal show={uploadModal} onHide={handleUploadModal} centered>
        <Modal.Body className="document-modal-body">
          <div className="upload-document " onClick={handleSelectModal}>
            <div className="content">
              <Icon icon="tabler:upload" width="40" height="40" />
              <p>Add To Knowledge Base</p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Modal 3 */}
      <Modal show={selectModal} onHide={handleSelectModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add to Knowledge Base</Modal.Title>
        </Modal.Header>
        <Modal.Body className="after-upload-modal">
          <div className="create-AI">
            <div className="top">
              <p className="text-center">
                Do you want AI magically turn documents or call recordings into
                FAQ flashcards or add them manually?
              </p>
            </div>
            <div className="bottom mt-3">
              <div className="checks mt-2">
                <div className="check-boxes" onClick={handleFaqModal}>
                  <label htmlFor="#">
                    <input type="radio" name="radio-button" id="1" />
                    <p id="">Manually add FAQ flashcard</p>
                  </label>
                </div>
                <div className="check-boxes" onClick={handleFileModal}>
                  <label htmlFor="#">
                    <input type="radio" name="radio-button" id="2" />
                    <p id="">Upload documents</p>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Modal 4 */}
      <Modal show={faqModal} onHide={setFaqModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Create A Flash Card</Modal.Title>
        </Modal.Header>
        <Modal.Body className="manually-faq-body">
          <div className="top">
            <h6>Question/Objection</h6>
            <input
              type="text"
              name=""
              id=""
              value={question}
              placeholder="eg. What's the name of your company?"
              onChange={(e) => setQuestion(e.target.value)}
            />
          </div>
          <div className="bottom mt-3">
            <h6>Answer/Response</h6>
            <textarea
              name=""
              id=""
              cols="30"
              rows="5"
              value={answer}
              placeholder="eg. Tesla Super Computers"
              onChange={(e) => setAnswer(e.target.value)}
            ></textarea>
          </div>
        </Modal.Body>
        <Modal.Footer className="manually-faq-footer">
          <div className="faq-btn">
            <button onClick={handleManuallyAddFaq}>Create</button>
          </div>
        </Modal.Footer>
      </Modal>
      {/* Modal 5 */}
      <Modal
        show={fileModal}
        onHide={setFileModal}
        centered
        size="lg"
        className="model_5"
      >
        {loading ? (
          <div
            className="loader"
            style={{
              // position: "absolute", width: "100%", zIndex: "2"
              display: "contents",
            }}
          >
            <Modal.Header closeButton>
              <Modal.Title> </Modal.Title>
            </Modal.Header>
            <HashLoader color="#0C72F7" />
            <h3 id="h3loader">AI is analyzing content...</h3>
          </div>
        ) : (
          <>
            <Modal.Header closeButton>
              {/* <Modal.Title>Create A Flash Card</Modal.Title> */}
            </Modal.Header>
            <Modal.Body className="upload-documents-body">
              <div className="top">
                <h2>Upload Documents</h2>
                <p>
                  Upload documents and voxr will use AI to magically turn them
                  into FAQ cards
                </p>
              </div>
              <div className="bottom mt-3">
                <label
                  htmlFor="DocUpload"
                  className="DocUpload"
                  style={{ cursor: "pointer" }}
                >
                  <Icon icon="tabler:upload" width="30" height="30" />
                  Click to upload file from computer
                </label>

                <input
                  type="file"
                  name=""
                  id="DocUpload"
                  className=""
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />

                {/* )} */}
              </div>
            </Modal.Body>
            <Modal.Footer className="upload-documents-footer">
              <div className="documents-btn">
                <button onClick={handleUploadDocumentPreview}>Create</button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </div>
  );
};

export default Knowledge;
